<template>
  <div class="d-flex flex-column min-vh-100">
    <barra-navegacao :visiblebutton="true"/>
    
    <div class="flex-grow-1">
      <b-row style="margin-top: 30px">
        <b-col cols="3"></b-col>
        <b-col cols="6">
          <b-card>
            <b-card-body>
              <div class="p-4 text-center">
                <h1><i class="ti-alert"></i></h1>
                <h2 class="py-2">Acesso negado</h2>
                <p class="pt-2">Você não tem autorização para acessar esse recurso</p>
                <p class="pt-2">Contate o administrador do sistema caso esse recurso seja essencial para o seu trabalho.</p>
                <b-button
                  variant="primary"
                  style="background-color: #303f9f; border-color: #303f9f"
                  @click="voltarParaHome"
                >
                  <span class="mat-button-wrapper">Voltar para home</span>
                </b-button>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="3"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import BarraNavegacao from '@/components/BarraNavegacao.vue';

export default {
  components: {
    BarraNavegacao
  },
  data(){
    return{
      mensagem: ''
    }
  },
  methods: {
    voltarParaHome() {
      const tokenCompleto = localStorage.getItem('token');
      let tokenValido = false;

      if (tokenCompleto && tokenCompleto.trim() !== '') {
        try {
        
          const tokenJwt = tokenCompleto.includes(' ') ? tokenCompleto.split(' ')[1] : tokenCompleto;
          const payload = JSON.parse(atob(tokenJwt.split('.')[1]));
          
          if (payload.exp && (payload.exp * 1000 > Date.now())) {
            tokenValido = true;
          }
        } catch (e) {
          console.error("Token inválido ou não decodificável", e);
        }
      }

      if (tokenValido) {
        this.$router.push('/chamados-abertos');
      } else {
        localStorage.clear();
        this.$router.push('/');
      }
    }
  }
}
</script>